import React, { useState } from 'react';

import { autoUpdate, flip, offset, safePolygon, useFloating, useHover, useInteractions } from '@floating-ui/react';
import { AnimatePresence } from 'framer-motion';

import { PopoverInside, PopoverWrapper } from './styles';

interface NavPopoverProps {
    button: React.ReactNode;
    children: React.ReactNode;
    allowOverflow?: boolean;
}

export const NavPopover = ({ button, children, allowOverflow }: NavPopoverProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        middleware: [
            offset({
                mainAxis: 30,
                alignmentAxis: -10,
            }),
            flip(),
        ],
        placement: 'right-start',
        whileElementsMounted: autoUpdate,
    });

    const hover = useHover(context, { mouseOnly: true, handleClose: safePolygon({ blockPointerEvents: true }) });

    const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

    return (
        <>
            <div ref={refs.setReference} {...getReferenceProps()}>
                {button}
            </div>

            <AnimatePresence>
                {isOpen && (
                    <PopoverWrapper ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
                        <PopoverInside
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -20 }}
                            transition={{ duration: 0.1, ease: 'easeInOut' }}
                            $allowOverflow={allowOverflow}
                        >
                            {children}
                        </PopoverInside>
                    </PopoverWrapper>
                )}
            </AnimatePresence>
        </>
    );
};
